import { IntegrationAuthenticationConfiguration } from './configuration';
import { IntegrationAuthenticationStatus } from './status';

export interface NoIntegrationAuthentication {
    type: 'NO_AUTHENTICATION';
}

export function createNoIntegrationAuthentication(): NoIntegrationAuthentication {
    return {
        type: 'NO_AUTHENTICATION',
    };
}

export interface IntegrationAuthentication {
    type: 'WITH_AUTHENTICATION';

    configuration: IntegrationAuthenticationConfiguration;
    status: IntegrationAuthenticationStatus;
}

export function createIntegrationAuthentication(
    configuration: IntegrationAuthenticationConfiguration,
    status: IntegrationAuthenticationStatus,
): IntegrationAuthentication {
    return {
        configuration,
        status,
        type: 'WITH_AUTHENTICATION',
    };
}

export type IntegrationAuthenticationOrNone = IntegrationAuthentication | NoIntegrationAuthentication;
